import BulkAddDataRooms from './BulkAddDataRooms.component';

export default BulkAddDataRooms;